import React from 'react';
import type {
  TaskDefinitionSimpleResponse,
  TaskTypeEnum} from 'src/api/ProactApiClient';
import {
  TaskDefinitionStateEnum
} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {TaskDefinitionTable} from 'src/app/tasks/TaskDefinitionTable/TaskDefinitionTable';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export interface RelatedTaskDefinitionListProps {
  taskType: TaskTypeEnum;
  filterFormId?: number;
}

export const RelatedTaskDefinitionList: React.FC<
  RelatedTaskDefinitionListProps
> = ({taskType, filterFormId}) => {
  const navigate = useAppNavigate();

  const handleViewClick = (row: TaskDefinitionSimpleResponse) =>
    navigate(PathUtility.TaskView(taskType, row.id, 'content'));

  return (
    <>
      <TaskDefinitionTable
        identifier={`form-related-${taskType}-definition-table`}
        taskType={taskType}
        defaultSorting={[{id: 'dueAt', desc: false}]}
        defaultColumnFilters={[
          {
            id: 'state',
            value: [TaskDefinitionStateEnum.Draft.toString()],
          },
        ]}
        filterFormId={filterFormId}
        onViewRowClick={handleViewClick}
      />
    </>
  );
};
